// extracted by mini-css-extract-plugin
export var checkbox = "_3g-0";
export var circle = "_3g-3";
export var horizontalContainer = "_3g-7";
export var sm = "_3g-5";
export var switch0 = "_3g-2";
export var switchDisabled = "_3g-8";
export var switchEnabled = "_3g-1";
export var textSwitchContainer = "_3g-9";
export var textSwitchOption = "_3g-a";
export var textSwitchOptionSelected = "_3g-b";
export var verticalContainer = "_3g-6";
export var xs = "_3g-4";